/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Mobile_App_Development_Ship_Desc4Inputs */

const en_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full App Store / Play Store submission, review readiness, assets, metadata, and store compliance handled.`)
};

const ar_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تقديم كامل لمتجر التطبيقات ومتجر بلاي, جاهزية المراجعة والأصول والبيانات الوصفية وامتثال المتجر.`)
};

const bn_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সম্পূর্ণ App Store/Play Store সাবমিশন, রিভিউ রেডিনেস, অ্যাসেট, মেটাডেটা ও স্টোর কমপ্লায়েন্স সামলানো হয়।`)
};

const de_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige App Store-/Play Store-Einreichung, Prüfungsbereitschaft, Assets, Metadaten und Store-Compliance gehandhabt.`)
};

const es_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicación completa en App Store y Play Store, preparación de revisión, assets, metadatos y cumplimiento de tienda gestionados.`)
};

const fr_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication complète sur l'App Store et le Play Store, préparation à la review, assets, métadonnées et conformité store gérées.`)
};

const pt_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicação completa na App Store e Play Store, preparação para revisão, assets, metadados e conformidade da loja tratados.`)
};

const zh_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理完整的应用商店/Play 商店提交、审查准备情况、资产、元数据和商店合规性。`)
};

const tr_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tam App Store / Play Store başvurusu, inceleme hazırlığı, asset'ler, meta veriler ve mağaza uyumu halledilir.`)
};

const ru_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полная подача в App Store / Play Store, готовность к ревью, ассеты, метаданные и комплаенс стора, всё закрыто.`)
};

const pl_svc_mobile_app_development_ship_desc4 = /** @type {(inputs: Svc_Mobile_App_Development_Ship_Desc4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełne zgłoszenie do App Store / Play Store, gotowość do review, assety, metadane i zgodność ze sklepem.`)
};

/**
* | output |
* | --- |
* | "Full App Store / Play Store submission, review readiness, assets, metadata, and store compliance handled." |
*
* @param {Svc_Mobile_App_Development_Ship_Desc4Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_mobile_app_development_ship_desc4 = /** @type {((inputs?: Svc_Mobile_App_Development_Ship_Desc4Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Mobile_App_Development_Ship_Desc4Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "bn") return bn_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "de") return de_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "es") return es_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "fr") return fr_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "pt") return pt_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "zh") return zh_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "tr") return tr_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "ru") return ru_svc_mobile_app_development_ship_desc4(inputs)
	if (locale === "pl") return pl_svc_mobile_app_development_ship_desc4(inputs)
	return en_svc_mobile_app_development_ship_desc4(inputs)
});
export { svc_mobile_app_development_ship_desc4 as "svc_mobile-app-development_SHIP_desc" }